import styled from '@emotion/styled/macro'
import { Button } from 'react-bootstrap'

const ComeBackLaterText = styled('span')`
  color: var(--CINight);
`

const ComeBackLaterBtn = styled(Button)`
  border: 0;
  padding: 0;
`

export { ComeBackLaterBtn, ComeBackLaterText }
